var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGroups = function SvgGroups(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137.985,
    height: 137.987,
    viewBox: "0 0 137.985 137.987",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2459",
    "data-name": "Group 2459",
    transform: "translate(-497.548 -159.233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26107",
    "data-name": "Path 26107",
    d: "M618.784,159.233a4.593,4.593,0,0,1,3.062,5.1c-.077,1.072.02,2.156-.035,3.232a3.943,3.943,0,0,1-4.226,4.071c-3.862.026-7.724.011-11.586.014h-1.406c-.038.426-.094.769-.094,1.112-.006,4.087.045,8.174-.036,12.259A2.064,2.064,0,0,0,605.9,187.3q21.08,9.491,42.111,19.093a19.482,19.482,0,0,1,2.284,1.134,4.023,4.023,0,0,1-3.366,7.223c-1.094-.363-2.141-.867-3.4-1.385v1.82q0,38.464.006,76.928c0,1.377-.043,2.787-1.13,3.741a4.549,4.549,0,0,1-2.546,1.291c-7.4.1-14.808.058-22.4.058v-1.622q0-13.809,0-27.619c0-3.284-1.449-4.729-4.767-4.732q-12.327-.01-24.655,0c-3.06,0-4.558,1.492-4.559,4.516q0,13.877-.007,27.754v1.718H582.02q-9.969,0-19.94,0c-3.128,0-4.69-1.572-4.691-4.744q-.008-27.551,0-55.1v-24.05c-.867.385-1.587.7-2.306,1.024-2.585,1.157-4.906.469-5.938-1.76s-.023-4.472,2.55-5.641q15.419-7,30.838-14c4.608-2.094,9.211-4.2,13.888-6.333V173.27c0-2.964.108-5.933-.034-8.89a4.792,4.792,0,0,1,2.994-5.147ZM600.438,245.51a17,17,0,1,0-16.975-17.056A17.01,17.01,0,0,0,600.438,245.51Z",
    transform: "translate(-33.914 0)",
    fill: "#b5b5c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26108",
    "data-name": "Path 26108",
    d: "M497.548,431.3c1.128-2.29,3.014-3.011,5.486-2.943,4.076.112,8.158.031,12.358.031v47.09c-4.816,0-9.566.062-14.314-.031-1.806-.035-2.788-1.407-3.53-2.91Z",
    transform: "translate(0 -178.282)",
    fill: "#e7e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26109",
    "data-name": "Path 26109",
    d: "M853.4,475.542V428.513c.43-.036.775-.09,1.122-.09,4.04,0,8.08-.008,12.12.016,3.041.018,4.624,1.633,4.625,4.678q0,18.921,0,37.843c0,3-1.557,4.576-4.532,4.58C862.338,475.547,857.941,475.542,853.4,475.542Z",
    transform: "translate(-235.735 -178.325)",
    fill: "#e7e7eb"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGroups, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/groups.10040a8c.svg";
export { ForwardRef as ReactComponent };